import {useLazyQuery} from "@apollo/client/react";
import {Query, ReactText} from "../graphql/generated/graphql-main.tsx";
import {gqlTemplates} from "../utils/gql-client.ts";
import {useXDispatch, useXSelector} from "../store/hooks.ts";
import {coreActions} from "../store/slice-core";
import {useEffect} from "react";
import {CoreStateType} from "../store/slice-core/types.ts";
import {empty, str2hash} from "../utils/utils.ts";
import {findBy} from "../utils/array-utils.ts";
import {useWpContext} from "../components/context/WordPressProvider.tsx";
import {DocumentNode} from "@apollo/client";

const set = coreActions.$setReactTexts;
const dtype: keyof CoreStateType = "react_texts";
const gnodeQuery: DocumentNode = gqlTemplates.reactTexts;
const gnodeMutation: DocumentNode = gqlTemplates.updateReactText;
const gkey: keyof Query = "reactTexts";

export default function useReactTexts<T extends ReactText[]>() {
    const dispatch = useXDispatch();
    const {is_fr} = useWpContext();
    const $texts = useXSelector(s => s.core[dtype] as T);

    const [fetch, {loading}] = useLazyQuery<Query>(gnodeQuery, {fetchPolicy: "cache-and-network"});

    const load = async () => {
        const {data} = await fetch();
        if (data?.[gkey] == null) return;
        dispatch(set(data?.[gkey] as T));
    }

    // given a human-readable string, find its translation in current site language
    const __ = (txt: string) => {
        const _entry = findBy($texts, "key", str2hash(txt));
        const _custom = is_fr ? _entry?.custom_fr : _entry?.custom_en;
        return _custom || _entry?.original || txt;
        // note: last-resort fallback to 'txt' in case text was not properly added to mongo
    }

    useEffect(() => {
        if (!empty($texts)) return;
        load().then(r => console.info(`dataset.texts -> loaded`));
    }, [$texts]);

    return {
        $texts,
        loading,
        __
    }
}